// Chart export configuration
export const EXPORT_CONFIG = {
    // Padding settings
    sidePadding: 30,      // Padding on left and right
    topPadding: 60,       // Padding on top
    bottomPadding: 50,    // Padding on bottom
    
    // Chart dimensions
    minWidth: 1000,       // Minimum chart width
    minHeight: 1000,      // Minimum chart height
    extraWidth: 60,       // Extra width to add to chart
    extraHeight: 80,      // Extra height to add to chart
    
    // Legend settings
    legendMarginTop: 20,   // Space between chart and legend
    legendExtraSpace: 40,  // Additional space for legend
    
    // Canvas settings
    scale: 2,             // Canvas scale for better quality
    backgroundColor: '#ffffff'
};

export const QUESTIONS_WITHOUT_SCORES = [
    'Lytis', 'Amzius', 'Padetis',
    'Laikas', 'Pareigos',
    'Kompiuteris', 'Issilavinimas', 'Religija', 'pilietybe', 'Neuroskirtingas',
    'Orientacija', 'Negalia',
    '2.2: Ką įmonė daro, kad užtikrintų įvairovę ir darbuotojų gerovę? (be balų)',
    '4.4: Ar žinote kolegą (-ę), kurie darbovietėje buvo diskriminuojami dėl savo: (be balų)',
    '4.3: Ar patyrėte diskriminaciją arba ar su Jumis buvo elgiamasi nesąžiningai dabartinėje darbo vietoje dėl Jūsų: (be balų)',
    '2.3: Ko norėtumėte, kad įmonė imtųsi siekdama užtikrinti įvairovę ir darbuotojų gerovę? (be balų)',
    '2.3.1: Kokias priemones taikote siekiant užtikrinti Į&Į darbo vietoje?',
    '2.4.1: Kas yra Jūsų vidinės komunikacijos apie Į&Į tikslinė grupė?',
    '2.5.1: Koks yra Jūsų veiklos sektorius?',
    "2.1.8: Ar įmonė turi lygių galimybių įgyvendinimui skirtą veiksmų planą?",
    '2.4.1: Koks yra Jūsų įmonės tipas?',
    '2.5.2: Koks yra Jūsų įmonės tipas?',
    '2.4.2: Kokias įtraukios komunikacijos priemones taikote?',
'2.1.3: Ar Jūsų organizacija priklauso bent vienai nacionalinei ar tarptautinei iniciatyvai, kuri skatina Į&Į arba verslo etiką (pabrėžiant lygias galimybes)?',
'2.3: Ar darbo atrankos metu Jūsų dabartinis  darbdavys sakė, kad stengiasi atsižvelgti į kandidačių/ -tų bei darbuotojų individualius poreikius (dėl kalbos, negalios, kita), teiravosi, ar Jūs tokių turite?',

// '2.1.9: Ar įmonė turi smurto ir priekabiavimo prevencijos politiką?',

    '2.4.2: Ar Jūsų įmonė yra prisijungusi prie Lietuvos Įvairovės chartijos?',
    '2.4.3: Ar Jūsų įmonė kaupia duomenis žemiau nurodytais klausimais?',
    'extra',
    '2.3: Ko įmonė nedaro, bet Jūs norėtumėte, kad darytų užtikrinant darbuotojų įvairovę ir gerovę?',
    '1.4: Manau, kad mano darbovietė turėtų skirti daugiau dėmesio šioms sritims:',
    '2.4: Manau, kad mano darbovietė turėtų skirti daugiau dėmesio šioms sritims:',
    '4.3: 4.2: Ar patyrėte diskriminacijos arba su Jumis buvo elgiamasi nesąžiningai dabartinėje darbo vietoje dėl Jūsų: ',
    '4.3: 4.2: Ar patyrėte diskriminacijos arba su Jumis buvo elgiamasi nesąžiningai dabartinėje darbo vietoje dėl Jūsų: (be balų)',
    '4.3: Ar patyrėte diskriminacijos arba su Jumis buvo elgiamasi nesąžiningai dabartinėje darbo vietoje dėl Jūsų: ',
    'LGBT',
    'Pilietis',

];

export const EXTRA_TEXT_QUESTIONS = [
    '4.4: Ar žinote kolegą (-ę), kurie darbovietėje buvo diskriminuojami dėl savo: (be balų)',
    '4.3: Ar patyrėte diskriminaciją arba ar su Jumis buvo elgiamasi nesąžiningai dabartinėje darbo vietoje dėl Jūsų: (be balų)',
];
